import React from "react";
import { CardListItem, Button, Typography, Tag } from "@ann/web-components";
import {
  FirstColumnWrapper,
  ColumnWrapper,
  RowWrapper,
  ActionWrapper,
  InlineTagWrapper,
} from "../../Tasks.styled";

const tasks = [
  {
    title: "Follow up with...",
    description: "Contact client...",
    status: "Pending",
    date: "03/20/2024",
  },
  {
    title: "Send service quote",
    description: "Quote for oil main...",
    status: "Pending",
    date: "03/22/2024",
  },
  {
    title: "Call for survey",
    description: "Check-in post-visit...",
    status: "Pending",
    date: "03/25/2024",
  },
  {
    title: "Schedule next appointment",
    description: "Align on availability...",
    status: "Pending",
    date: "03/28/2024",
  },
  {
    title: "Review email campaign",
    description: "Check bounce rate...",
    status: "Pending",
    date: "03/29/2024",
  },
  {
    title: "Internal QA review",
    description: "Finalize draft process...",
    status: "Pending",
    date: "03/30/2024",
  },
];

const TaskContent = () => {
  return (
    <CardListItem>
      {tasks.map((task, index) => (
        <CardListItem.Row key={index}>
          <CardListItem.RowContent>
            <RowWrapper>
              <FirstColumnWrapper className="col-1">
                <Typography category="subtitle" weight="bold" size="small">
                  {task.title}
                </Typography>
              </FirstColumnWrapper>

              <ColumnWrapper className="col-2">
                <Typography category="subtitle" weight="bold" size="small">
                  Description
                </Typography>
                <Typography category="body" weight="regular" size="medium" color="body">
                  {task.description}
                </Typography>
              </ColumnWrapper>

              <ColumnWrapper className="col-3">
                <Typography category="subtitle" weight="bold" size="small">
                  Status
                </Typography>
                <InlineTagWrapper>
                  <Tag text={task.status} color="alert" size="small" />
                </InlineTagWrapper>
              </ColumnWrapper>

              <ColumnWrapper className="col-4">
                <Typography category="subtitle" weight="bold" size="small">
                  Date
                </Typography>
                <Typography category="body" weight="regular" size="medium" color="body">
                  {task.date}
                </Typography>
              </ColumnWrapper>
            </RowWrapper>
          </CardListItem.RowContent>

          <CardListItem.RowActions>
            <ActionWrapper>
              <Button
                size="small"
                type="primary"
                label="complete"
                pill={true}
              />
            </ActionWrapper>
          </CardListItem.RowActions>
        </CardListItem.Row>
      ))}
    </CardListItem>
  );
};

export default TaskContent;
